import React from "react";
import styled from "styled-components";

const CardList = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  width: 100%;
  justify-content: center;
`;

const CardItem = styled.li`
  align-items: center;
  display: flex;
  padding: 0px 4px;
`;

const CardIconWrapper = styled.div`
  flex: 0 0 38px;
  height: 25px;
`;

const CardIcon = styled.div`
  height: 0px;
  overflow: hidden;
  padding: 0px 0px 63.15%;
  position: relative;
  width: 38px;
`;

const CardSVG = styled.svg`
  height: 100%;
  left: 0px;
  position: absolute;
  top: 0px;
  width: 100%;
`;
export const CardIcons = () => (
  <CardList>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="master-card-art-title"
            data-testid="master-card-art"
            height={24}
            role="img"
            viewBox="0 0 38 24"
            width={38}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="master-card-art-title">Mastercard</title>
            <g fill="none" fillRule="evenodd">
              <path
                d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                fill="#000"
                opacity=".07"
              />
              <path
                d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                fill="#FFF"
              />
              <circle cx={15} cy={12} fill="#EB001B" r={7} />
              <circle cx={23} cy={12} fill="#F79E1B" r={7} />
              <path
                d="M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7 0 2.3 1.2 4.5 3 5.7 1.8-1.2 3-3.3 3-5.7z"
                fill="#FF5F00"
              />
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="discover-card-art-title"
            data-testid="discover-card-art"
            height={24}
            role="img"
            viewBox="0 0 38 24"
            width={38}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="discover-card-art-title">Discover</title>
            <g fill="none" fillRule="evenodd">
              <path
                d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                fill="#000"
                opacity=".07"
              />
              <path
                d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                fill="#FFF"
              />
              <path
                d="M37 16.95V21c0 1.1-.9 2-2 2H23.228c7.896-1.815 12.043-4.601 13.772-6.05z"
                fill="#EDA024"
              />
              <path d="M9 11h20v2H9z" fill="#494949" />
              <path
                d="M22 12c0 1.7-1.3 3-3 3s-3-1.4-3-3 1.4-3 3-3c1.7 0 3 1.3 3 3z"
                fill="#EDA024"
              />
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="visa-card-art-title"
            data-testid="visa-card-art"
            height={24}
            role="img"
            viewBox="0 0 38 24"
            width={38}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="visa-card-art-title">Visa</title>
            <g fill="none" fillRule="evenodd">
              <path
                d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                fill="#000"
                opacity=".07"
              />
              <path
                d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                fill="#FFF"
              />
              <path
                d="M28.3 10.1H28c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5L27 8.7c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3H18c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2l-1.7.1zM5 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0H9.7c-.1 0-.2 0-.2-.2L7.9 9.5c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5L5 8.2z"
                fill="#142688"
                fillRule="nonzero"
              />
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="maestro-card-art-title"
            data-testid="maestro-card-art"
            height={24}
            role="img"
            viewBox="0 0 38 24"
            width={38}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="maestro-card-art-title">Maestro</title>
            <g fill="none" fillRule="evenodd">
              <path
                d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                fill="#000"
                opacity=".07"
              />
              <path
                d="M35.2 23H2.8c-.9936 0-1.8-.77917-1.8-1.73892V2.73892C1 1.77917 1.8064 1 2.8 1h32.4c.9936 0 1.8.77917 1.8 1.73892v18.52216C37 22.22083 36.1936 23 35.2 23"
                fill="#000"
                fillRule="nonzero"
              />
              <g fillRule="nonzero">
                <path
                  d="M28.8451 19.9992l.05446.01447a.06222.06222 0 0 1 .03063 0c.0034.0068.0034.01617 0 .02297a.02524.02524 0 0 1 0 .02213.04722.04722 0 0 1-.03063 0h-.05445v-.05956zm.05446-.04254l-.10465.00256v.21867h.04765v-.08169h.02212l.06722.08169h.05785l-.07317-.08169c.01957-.0017.03829-.00936.05275-.02297.01192-.01106.01787-.02808.01787-.04424.00085-.02042-.0068-.03914-.02212-.0519-.01872-.01447-.04254-.02128-.06552-.02043zm-.01446-.07232c.02467 0 .0485.0051.07147.01532.0936.03999.13699.1489.09615.24249-.00936.02042-.02213.03999-.0383.05616-.01616.01616-.03573.03063-.05785.03999-.02212.00936-.0468.01531-.07147.01446v-.00936c-.0502 0-.09785-.01957-.13273-.0553-.06467-.06977-.06467-.17868 0-.2493.01701-.01702.03743-.02978.05956-.04a.19675.19675 0 0 1 .07317-.01446zm0-.0519l-.01276.00255c-.02808 0-.05616.0051-.08254.01447a.2554.2554 0 0 0-.07742.04935c-.02213.02212-.03914.04764-.0519.07572a.23011.23011 0 0 0 0 .18379.2505.2505 0 0 0 .22462.14464.22738.22738 0 0 0 .09444-.02042c.02808-.01106.05446-.02808.07743-.04935.02127-.02127.03914-.0468.05275-.07487a.2374.2374 0 0 0 0-.18379.29487.29487 0 0 0-.05275-.07572c-.02297-.02128-.04935-.03744-.07743-.04935a.23834.23834 0 0 0-.09444-.01702zm-14.08163-1.51792c.39735-.00851.72748.3063.736.7045.0085.39735-.30717.72663-.70452.73514-.0068 0-.01276.00085-.01957.00085-.39309.00936-.71982-.3029-.72918-.696 0-.02212 0-.0451.0017-.06721h.00596c.02212-.37693.33183-.67303.70961-.67728zm12.28633-.08509c.1038.0034.2059.02723.2995.06977.09274.03403.17868.08764.2493.1574.06892.07148.12252.15571.1574.24846a.87053.87053 0 0 1 0 .61857.7295.7295 0 0 1-.1574.2493c-.07062.06892-.1557.12252-.2493.1574a.81282.81282 0 0 1-.5905 0c-.08933-.03573-.16931-.08933-.23653-.1574a.7295.7295 0 0 1-.1574-.2493.8615.8615 0 0 1 0-.61857c.03488-.09275.08848-.17698.1574-.24845.06722-.06892.1472-.12167.23654-.1574a.78626.78626 0 0 1 .29694-.05531l-.00595-.01447zm-9.42235-.02467a.16418.16418 0 0 1 .02892 0c.32673-.00766.59645.25185.60326.57773h-1.23544c.01787-.32078.28163-.57348.60326-.57773zm.03999-.45861c-.68834.01106-1.23715.57773-1.22608 1.26607.01106.68578.57432 1.23373 1.26011 1.22608.3548.0119.70195-.10721.97508-.33439l-.2493-.38288c-.1974.1574-.44074.24504-.6926.24845-.3565.03148-.67302-.22718-.71386-.58284h1.76807c.00766-.05956.0068-.12507.0068-.19484 0-.7479-.46286-1.24565-1.12822-1.24565zm-2.91418-.0034c-.01446 0-.02978 0-.04424.00084-.68834 0-1.2465.55816-1.24565 1.2465 0 .6875.55816 1.2448 1.24565 1.24565.29014.01106.56922-.11912.74705-.34885v.2893h.51817l.0051-1.1844v-1.18864h-.52327v.2893c-.16847-.21783-.42713-.3463-.7028-.3497zm12.29654-.0017a1.33025 1.33025 0 0 0-.51051.1021c-.1506.0604-.2876.1506-.40416.26376a1.23695 1.23695 0 0 0-.26632.3965 1.32193 1.32193 0 0 0 0 .9972c.06212.14804.1523.28333.26632.39564a1.22366 1.22366 0 0 0 .40416.26462c.32928.12763.69344.12763 1.02187 0a1.23434 1.23434 0 0 0 .4067-.26462c.11487-.11231.20677-.24674.26888-.39564.13018-.31907.13018-.67728 0-.9972-.06296-.1489-.154-.28334-.26887-.3965-.11912-.11487-.25951-.2059-.41352-.26632-.1591-.06296-.32757-.0953-.4986-.09444l-.00595-.0051zm-1.78935 0l.01106.00935a.70225.70225 0 0 0-.62878.3497v-.28929h-.51306v2.37984h.51817v-1.33329c0-.39394.15996-.61346.4986-.61346.1106-.00086.22037.01871.32417.0604l.15911-.4986c-.11827-.04254-.24334-.06466-.36927-.06466zm-5.02173 0c-.60837 0-.9972.28928-.9972.76236 0 .38884.29014.62793.82277.7028l.2493.03489c.28419.03999.41862.11486.41862.2493 0 .18463-.18889.28929-.54284.28929-.28504.00765-.56412-.07998-.793-.2493l-.2493.40415a1.71571 1.71571 0 0 0 1.02953.30801c.6858 0 1.08399-.3582 1.08399-.77683 0-.41947-.31311-.63814-.83213-.71301l-.2493-.03489c-.22378-.02978-.4033-.05956-.4033-.23398 0-.17443.16931-.27994.4535-.27994.26206.0034.51987.07403.74705.20506l.23228-.41862c-.2927-.17442-.62963-.26036-.96997-.2493zm-8.20138-.00171c-.3029.0102-.58199.16932-.74535.42457-.16507-.27397-.46712-.43648-.78789-.42287-.27823-.01446-.54455.11997-.6977.35396v-.2944h-.51817v2.37984h.52327V18.8548c-.04424-.30376.16762-.58539.47138-.62793a.48762.48762 0 0 1 .11146-.0051c.34374 0 .51817.22377.51817.62792v1.32393h.52413v-1.31882c-.04-.30716.17527-.5888.48243-.62878.03318-.00426.06722-.00596.1004-.00426.35395 0 .52327.22378.52327.62793v1.32393l.52158.0068V18.6855c.03318-.48754-.33439-.91042-.82193-.94445a.83713.83713 0 0 0-.11316 0c-.03063-.00255-.06126-.00255-.0919-.0017zm10.0639-.65686v.72323h-.48414v.47392h.48413v1.08314c0 .5539.21442.88318.82703.88318.22888.00085.4535-.06381.6475-.18463l-.1489-.44415c-.13869.08254-.29694.12933-.4586.13444-.25952 0-.3446-.1489-.3446-.3982v-1.07888h.84575v-.46882h-.84575v-.72323h-.52243z"
                  fill="#FFF"
                />
                <path
                  d="M16.28797 14.0592h5.22234V4.67387h-5.22234z"
                  fill="#7673C0"
                />
                <path
                  d="M16.62014 9.36593c-.0017-1.8314.83876-3.56193 2.27943-4.69224-2.5915-2.0366-6.34324-1.58688-8.3807 1.00548-2.03662 2.5915-1.58689 6.34325 1.00547 8.37986 2.164 1.70145 5.21123 1.70145 7.37523 0-1.44067-1.13031-2.28114-2.86169-2.27943-4.6931"
                  fill="#EB001B"
                />
                <path
                  d="M28.45441 13.1037v-.271h-.07l-.081.193-.081-.193h-.07v.271h.05v-.204l.076.177h.052l.076-.177v.206l.048-.002zm-.448 0v-.225h.091v-.046h-.23v.046h.091v.225h.048zM28.55671 9.36593c0 3.29603-2.67187 5.9679-5.96875 5.9679-1.33722 0-2.63682-.44887-3.68847-1.27651 2.5915-2.03661 3.04123-5.78835 1.00462-8.37986-.29326-.37363-.63099-.71136-1.00462-1.00548 2.5915-2.03746 6.3441-1.58773 8.3807 1.00377.8268 1.05165 1.27652 2.3504 1.27652 3.68847v.00171z"
                  fill="#00A1DF"
                />
              </g>
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="amex-card-art-title"
            data-testid="amex-card-art"
            height={24}
            role="img"
            viewBox="0 0 38 24"
            width={38}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="amex-card-art-title">American Express</title>
            <defs>
              <rect height={36} id="amexCardArt-a" rx={4} width={324} />
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="translate(-61 -6)">
                <mask fill="#fff" id="amexCardArt-b">
                  <use xlinkHref="#amexCardArt-a" />
                </mask>
                <g fillRule="nonzero" mask="url(#amexCardArt-b)">
                  <path
                    d="M96 6H64c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V9c0-1.7-1.4-3-3-3z"
                    fill="#000"
                    opacity=".07"
                  />
                  <path
                    d="M96 7c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H64c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h32"
                    fill="#006FCF"
                  />
                  <path
                    d="M69.971 16.268l.774 1.876h-1.542l.768-1.876zm16.075.078h-2.977v.827h2.929v1.239h-2.923v.922h2.977v.739l2.077-2.245-2.077-2.34-.006.858zm-14.063-2.34h3.995l.887 1.935.822-1.941h10.37l1.078 1.19L90.25 14h4.763l-3.519 3.852 3.483 3.828h-4.834l-1.078-1.19-1.125 1.19H71.03l-.494-1.19h-1.13l-.495 1.19H65L68.286 14h3.43l.267.006zm8.663 1.078h-2.239l-1.5 3.536-1.625-3.536H73.06v4.81L71 15.084h-1.993l-2.382 5.512h1.555l.494-1.19h2.596l.494 1.19h2.72v-3.935l1.751 3.941h1.19l1.74-3.929v3.93h1.458l.024-5.52-.001.001zm9.34 2.768l2.531-2.768h-1.822l-1.601 1.726-1.548-1.726h-5.894v5.518h5.81l1.614-1.738 1.548 1.738h1.875l-2.512-2.75h-.001z"
                    fill="#FFF"
                  />
                </g>
              </g>
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="unionpay-card-art-title"
            data-testid="unionpay-card-art"
            height={24}
            role="img"
            viewBox="0 0 38 24"
            width={38}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="unionpay-card-art-title">UnionPay</title>
            <g fill="none" fillRule="evenodd">
              <path d="M-308-18H67v60h-375z" />
              <g fillRule="nonzero">
                <path
                  d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                  fill="#000"
                  opacity="0.07"
                />
                <path
                  d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                  fill="#FFF"
                />
              </g>
              <g fillRule="nonzero">
                <path
                  d="M11.997 4h6.37c.888 0 1.441.73 1.234 1.63l-2.965 12.836c-.21.896-1.1 1.627-1.99 1.627H8.279c-.888 0-1.442-.731-1.234-1.627L10.01 5.63c.207-.9 1.097-1.63 1.987-1.63"
                  fill="#E21836"
                />
                <path
                  d="M17.655 4h7.194c.873 0 .48.73.274 1.63l-2.912 12.836c-.204.896-.14 1.627-1.015 1.627h-7.194c-.875 0-1.416-.731-1.21-1.627l2.91-12.836c.208-.9 1.08-1.63 1.953-1.63"
                  fill="#00447C"
                />
                <path
                  d="M24.641 4h6.37c.89 0 1.443.73 1.234 1.63L29.28 18.466c-.21.896-1.1 1.627-1.99 1.627h-6.367c-.89 0-1.443-.731-1.234-1.627L22.654 5.63C22.86 4.73 23.75 4 24.64 4"
                  fill="#007B84"
                />
                <path
                  d="M13.09 7.473c-.654.007-.847 0-.909-.016l-.467 2.3c-.095.44-.164.754-.4.957a.684.684 0 01-.469.175c-.29 0-.46-.154-.488-.446l-.005-.1.088-.594s.464-1.984.547-2.247a.202.202 0 00.007-.03c-.903.009-1.063 0-1.074-.015a3.766 3.766 0 00-.028.144l-.474 2.237-.04.19-.079.62c0 .184.034.334.101.461.216.403.831.463 1.18.463.448 0 .868-.101 1.152-.287.494-.312.623-.799.738-1.232l.053-.222s.478-2.06.56-2.329a.085.085 0 01.008-.03zm1.626 1.662c-.115 0-.326.03-.515.129-.068.038-.133.081-.202.124l.062-.238-.034-.04c-.4.087-.49.098-.86.154l-.032.022c-.042.38-.08.667-.24 1.416a93.9 93.9 0 01-.187.83l.017.035a8.37 8.37 0 01.824-.016l.027-.031c.042-.23.047-.283.14-.748.044-.22.135-.704.18-.876a.587.587 0 01.24-.08c.186 0 .163.172.156.24a9.176 9.176 0 01-.144.815l-.046.209c-.032.154-.068.303-.1.456l.014.03a8.3 8.3 0 01.807-.015l.038-.031c.058-.358.075-.454.177-.975l.052-.24c.1-.469.15-.707.074-.9-.08-.217-.272-.27-.448-.27zm1.815.491c-.199.04-.326.068-.452.086-.125.021-.246.04-.438.069l-.016.015-.014.011c-.02.153-.034.285-.06.44a8.357 8.357 0 01-.114.606 2.62 2.62 0 01-.09.342c-.025.07-.051.14-.1.337l.011.018.01.017c.18-.01.297-.016.417-.017.121-.005.246 0 .44 0l.016-.014.018-.016c.028-.178.032-.226.05-.313.016-.093.046-.222.117-.567.034-.162.072-.323.107-.488l.11-.488-.005-.02-.007-.018zm.004-.662c-.18-.114-.497-.078-.71.08-.214.154-.238.373-.058.488.178.111.496.078.707-.08.213-.158.24-.375.061-.488zm1.092 2.638c.366 0 .74-.107 1.022-.427.217-.259.317-.644.351-.803.112-.526.025-.771-.085-.92-.166-.229-.46-.302-.766-.302-.184 0-.622.02-.963.356-.246.243-.36.573-.428.889-.069.322-.148.901.35 1.117.154.07.376.09.52.09zM17.6 10.42c.084-.398.184-.733.437-.733.2 0 .214.249.125.649-.015.088-.088.418-.186.559-.069.103-.15.166-.24.166-.026 0-.185 0-.188-.252a1.825 1.825 0 01.052-.39zm2.315 1.132l.028-.031c.04-.23.047-.283.137-.747.045-.22.138-.704.181-.877.083-.04.163-.08.243-.08.183 0 .16.171.154.24a8.317 8.317 0 01-.145.815l-.043.208c-.034.155-.07.304-.102.457l.014.03c.375-.02.485-.02.806-.015l.039-.031c.056-.358.071-.454.177-.975l.05-.24c.1-.47.152-.707.077-.9-.082-.217-.276-.27-.45-.27-.115 0-.326.03-.514.129a3 3 0 00-.2.124l.057-.238-.031-.04c-.4.087-.492.098-.862.154l-.029.022c-.044.38-.08.667-.24 1.416-.06.276-.124.554-.187.83l.017.035c.38-.022.493-.022.823-.016zm2.756.016l.165-.853s.12-.535.127-.554c0 0 .037-.056.075-.078h.055c.521 0 1.11 0 1.571-.363.314-.248.528-.616.624-1.062.025-.11.043-.24.043-.37 0-.17-.032-.34-.125-.472-.235-.352-.703-.358-1.244-.36l-.267.002c-.692.01-.97.006-1.083-.008l-.028.15-.248 1.23-.621 2.733c.604-.008.852-.008.956.005zm.46-2.182l.262-1.22.008-.064.004-.047.106.011.556.051c.215.09.303.318.241.616a.89.89 0 01-.434.613c-.176.094-.39.102-.611.102h-.143l.01-.062zm1.64 1.057c-.069.317-.149.897.348 1.103a.91.91 0 00.444.086c.152-.01.293-.09.424-.208l-.036.145.023.03c.357-.015.468-.015.854-.012l.035-.029c.057-.354.11-.699.257-1.378.071-.325.143-.647.216-.97l-.011-.036c-.4.079-.506.096-.89.154l-.03.025-.011.097a.56.56 0 00-.28-.247c-.171-.071-.572.021-.917.357-.243.24-.359.568-.425.883zm.84.019c.085-.391.183-.722.438-.722.16 0 .246.159.228.43a7.477 7.477 0 01-.046.218c-.025.116-.053.232-.08.347a.865.865 0 01-.094.203.43.43 0 01-.31.16c-.026 0-.183 0-.188-.247a1.81 1.81 0 01.052-.389zm4.38-1.292l-.03-.037a8.986 8.986 0 01-.83.151l-.027.029-.005.018v-.006c-.271.666-.263.522-.483 1.047l-.003-.064-.055-1.138-.034-.037c-.414.085-.424.099-.806.151l-.03.029c-.004.013-.004.028-.007.045l.003.005c.047.261.036.203.084.615.022.202.052.406.074.605.038.334.06.499.105 1.009-.258.455-.32.627-.568 1.027l.002.004-.175.296c-.02.03-.038.052-.064.061a.249.249 0 01-.114.018h-.097l-.144.512.494.01a.604.604 0 00.571-.342l.311-.57h-.005l.033-.04c.209-.481 1.8-3.398 1.8-3.398zm-5.22 6.73h-.209l.777-2.745h.257l.082-.283.008.315c-.01.194.133.366.509.338h.435l.15-.529h-.164c-.094 0-.138-.025-.133-.08l-.007-.32h-.805v.002c-.26.006-1.038.027-1.195.072-.19.052-.39.207-.39.207l.078-.284h-.753l-.157.562-.787 2.786h-.152l-.15.525h1.5l-.05.175h.738l.05-.175h.206l.163-.567zm-.614-2.187a3.24 3.24 0 00-.345.143l.2-.7h.597l-.144.51s-.185.012-.308.047zm.011 1.002s-.188.025-.311.055c-.122.04-.35.164-.35.164l.205-.73h.602l-.146.51zm-.335 1.19h-.6l.174-.615h.598l-.172.616zm1.445-1.701h.865l-.124.43h-.877l-.131.47h.766l-.58.874a.243.243 0 01-.118.105.328.328 0 01-.156.047h-.212l-.146.516h.556c.29 0 .46-.141.586-.326l.398-.582.086.591a.273.273 0 00.143.201c.056.03.113.081.194.089.088.004.15.007.192.007h.274l.164-.576h-.108c-.062 0-.168-.012-.186-.032-.019-.025-.019-.064-.028-.123l-.087-.593h-.355l.156-.198h.874l.135-.47h-.81l.126-.43h.807l.15-.53h-2.407l-.147.53zm-7.305 1.822l.202-.718h.83l.151-.534h-.83l.127-.441h.811l.15-.517h-2.03l-.147.517h.461l-.123.441h-.462l-.154.543h.461l-.269.95c-.036.125.017.173.051.231.035.057.07.095.149.116a.84.84 0 00.212.031h.936l.166-.59-.414.06c-.08 0-.302-.01-.278-.09zm.095-3.436l-.21.406a.467.467 0 01-.122.17c-.032.02-.096.03-.188.03h-.11l-.146.52h.364c.175 0 .31-.07.374-.104.07-.04.087-.017.14-.072l.124-.114h1.137l.151-.54h-.832l.145-.296h-.827zm1.68 3.446c-.02-.03-.006-.082.024-.192l.311-1.1h1.106c.161-.002.278-.004.354-.01a.69.69 0 00.266-.096c.1-.058.15-.12.193-.19a1.67 1.67 0 00.191-.463l.39-1.391-1.147.007s-.354.055-.51.117c-.156.069-.38.26-.38.26l.103-.381h-.709l-.993 3.518a2.305 2.305 0 00-.064.295c-.002.064.076.128.126.176.06.048.147.04.232.048.088.007.214.011.388.011h.545l.167-.603-.488.05a.126.126 0 01-.105-.056zm.536-2.034h1.162l-.074.247c-.01.006-.036-.012-.154.003h-1.006l.072-.25zm.232-.83h1.172l-.084.298s-.552-.006-.64.011c-.39.072-.617.295-.617.295l.17-.604zm.882 1.905a.133.133 0 01-.046.077c-.024.016-.062.022-.12.022h-.165l.01-.301h-.688l-.028 1.472c-.001.107.008.168.08.218.074.061.298.069.6.069h.431l.156-.552-.376.023-.125.007a.133.133 0 01-.051-.034c-.016-.017-.043-.006-.038-.113l.003-.377.394-.018a.493.493 0 00.38-.144c.075-.068.1-.145.127-.25l.066-.334h-.541l-.07.235z"
                  fill="#FEFEFE"
                />
              </g>
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
    <CardItem>
      <CardIconWrapper>
        <CardIcon>
          <CardSVG
            aria-labelledby="diners-card-art-title"
            data-testid="diners-card-art"
            xmlns="http://www.w3.org/2000/svg"
            width={38}
            height={24}
            viewBox="0 0 38 24"
          >
            <title id="diners-card-art-title">Diners</title>
            <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
              <g>
                <path
                  fill="#000"
                  fillRule="nonzero"
                  d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"
                  opacity="0.07"
                />
                <path
                  fill="#FFF"
                  fillRule="nonzero"
                  d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"
                />
                <g transform="translate(9.625 4.125)">
                  <path
                    fill="#0079BE"
                    d="M10.736 14.222c3.968.018 7.59-3.17 7.59-7.05 0-4.241-3.622-7.173-7.59-7.172H7.321C3.305-.001 0 2.932 0 7.173c0 3.88 3.305 7.067 7.32 7.049h3.416z"
                  />
                  <path
                    fill="#FFF"
                    d="M7.337.588C3.667.588.694 3.502.693 7.098c.001 3.595 2.975 6.509 6.644 6.51 3.67-.001 6.644-2.915 6.645-6.51 0-3.596-2.975-6.51-6.645-6.51zm-4.211 6.51c.003-1.757 1.124-3.255 2.703-3.85v7.7c-1.58-.595-2.7-2.092-2.703-3.85zm5.718 3.852V3.247c1.58.594 2.703 2.093 2.705 3.851-.002 1.759-1.124 3.257-2.705 3.852z"
                  />
                  <path
                    fill="#0079BE"
                    d="M10.736 14.222c3.968.018 7.59-3.17 7.59-7.05 0-4.241-3.622-7.173-7.59-7.172H7.321C3.305-.001 0 2.932 0 7.173c0 3.88 3.305 7.067 7.32 7.049h3.416z"
                  />
                  <path
                    fill="#FFF"
                    d="M7.337.588C3.667.588.694 3.502.693 7.098c.001 3.595 2.975 6.509 6.644 6.51 3.67-.001 6.644-2.915 6.645-6.51 0-3.596-2.975-6.51-6.645-6.51zm-4.211 6.51c.003-1.757 1.124-3.255 2.703-3.85v7.7c-1.58-.595-2.7-2.092-2.703-3.85zm5.718 3.852V3.247c1.58.594 2.703 2.093 2.705 3.851-.002 1.759-1.124 3.257-2.705 3.852z"
                  />
                </g>
              </g>
            </g>
          </CardSVG>
        </CardIcon>
      </CardIconWrapper>
    </CardItem>
  </CardList>
);
